"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CardSectionHeader", {
  enumerable: true,
  get: function get() {
    return _CardSectionHeader.default;
  }
});
Object.defineProperty(exports, "CardSectionContent", {
  enumerable: true,
  get: function get() {
    return _CardSectionContent.default;
  }
});
exports.default = exports.StyledCardSection = void 0;

var React = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _defaultTheme = _interopRequireDefault(require("../../defaultTheme"));

var _ChevronDown = _interopRequireDefault(require("../../icons/ChevronDown"));

var _Icon = require("../../Icon");

var _consts = require("../../Icon/consts");

var _mediaQuery = _interopRequireDefault(require("../../utils/mediaQuery"));

var _CardSectionContext = _interopRequireDefault(require("./CardSectionContext"));

var _CardSectionHeader = _interopRequireDefault(require("./CardSectionHeader"));

var _CardSectionContent = _interopRequireDefault(require("./CardSectionContent"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var StyledCardSectionIconRight = (0, _styledComponents.default)(_ChevronDown.default).withConfig({
  displayName: "CardSection__StyledCardSectionIconRight",
  componentId: "o8zdxr-0"
})(["align-self:center;transition:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.orbit.durationFast;
});
StyledCardSectionIconRight.defaultProps = {
  theme: _defaultTheme.default
};

var StyledCardSectionContent = _styledComponents.default.div.withConfig({
  displayName: "CardSection__StyledCardSectionContent",
  componentId: "o8zdxr-1"
})(["font-family:", ";font-size:", ";line-height:", ";color:", ";border-top:", ";padding-top:", ";overflow:hidden;"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.orbit.fontFamily;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.orbit.fontSizeTextNormal;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.orbit.lineHeightTextNormal;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.orbit.colorTextPrimary;
}, function (_ref6) {
  var theme = _ref6.theme,
      expanded = _ref6.expanded;
  return expanded ? "1px solid ".concat(theme.orbit.paletteCloudNormal) : "0px solid ".concat(theme.orbit.paletteCloudNormal);
}, function (_ref7) {
  var theme = _ref7.theme,
      expanded = _ref7.expanded;
  return expanded && "".concat(theme.orbit.spaceMedium);
});

StyledCardSectionContent.defaultProps = {
  theme: _defaultTheme.default
};

var StyledCardSection = _styledComponents.default.div.withConfig({
  displayName: "CardSection__StyledCardSection",
  componentId: "o8zdxr-2"
})(["width:100%;padding:", ";box-sizing:border-box;position:relative;background:", ";", ""], function (_ref8) {
  var theme = _ref8.theme;
  return theme.orbit.spaceMedium;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.orbit.backgroundCard;
}, _mediaQuery.default.desktop((0, _styledComponents.css)(["padding:", ";"], function (_ref10) {
  var theme = _ref10.theme;
  return theme.orbit.spaceLarge;
})));

exports.StyledCardSection = StyledCardSection;
StyledCardSection.defaultProps = {
  theme: _defaultTheme.default
};

var StyledCardSectionHeader = _styledComponents.default.div.withConfig({
  displayName: "CardSection__StyledCardSectionHeader",
  componentId: "o8zdxr-3"
})(["margin-bottom:", ";display:flex;flex-direction:row;cursor:pointer;position:relative;min-height:", ";"], function (_ref11) {
  var theme = _ref11.theme,
      expanded = _ref11.expanded;
  return expanded && theme.orbit.spaceMedium;
}, function (_ref12) {
  var expandable = _ref12.expandable;
  return expandable && (0, _Icon.getSize)(_consts.ICON_SIZES.MEDIUM);
});

StyledCardSectionHeader.defaultProps = {
  theme: _defaultTheme.default
};

var CardSection =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CardSection, _React$Component);

  function CardSection() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, CardSection);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CardSection)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "injectCallbackAndToggleSection", function () {
      var _this$props = _this.props,
          handleToggleSection = _this$props.handleToggleSection,
          onClose = _this$props.onClose,
          onExpand = _this$props.onExpand,
          expanded = _this$props.expanded;
      handleToggleSection(); // First do toggle

      if (expanded && onClose) {
        // If is expanded -> action is closing
        onClose();
      }

      if (!expanded && onExpand) {
        // if is closed > action is expanding
        onExpand();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (ev) {
      if (ev.keyCode === 13 || ev.keyCode === 32) {
        ev.preventDefault();

        _this.injectCallbackAndToggleSection();
      }
    });

    return _this;
  }

  _createClass(CardSection, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
          handleToggleSection = _this$props2.handleToggleSection,
          initialExpanded = _this$props2.initialExpanded,
          setInitialExpandedSection = _this$props2.setInitialExpandedSection;

      if (initialExpanded) {
        handleToggleSection();
        setInitialExpandedSection();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          children = _this$props3.children,
          dataTest = _this$props3.dataTest,
          expandable = _this$props3.expandable,
          expanded = _this$props3.expanded;
      return React.createElement(StyledCardSection, {
        "data-test": dataTest,
        expandable: expandable,
        expanded: expanded
      }, React.createElement(_CardSectionContext.default.Provider, {
        value: {
          expandable: expandable,
          expanded: expanded,
          handleToggleSection: this.injectCallbackAndToggleSection,
          onKeyDownHandler: this.handleKeyDown
        }
      }, children));
    }
  }]);

  return CardSection;
}(React.Component);

var _default = CardSection;
exports.default = _default;